import * as React from 'react';
import Lottie from 'react-lottie';
import 'semantic-ui-css/components/dimmer.min.css';
import { Dimmer } from 'semantic-ui-react';
import { greenLoading as loaderAnim } from '@assets';
import { CoreHelper } from 'ff-shared-components-core';

interface LoaderProps {
	/** Loader visibility */
	loading?: boolean;
	/** Loader in full page */
	page?: boolean;
	/** The size of the loader */
	size?: number;
	animation?: string | object;
	/** Set Loader backgroundColor */
	backgroundColor?: string;
}

const LoaderComponent = (props: LoaderProps): JSX.Element => {
	const { loading, page = false, size = 100, backgroundColor, animation } = props;

	const animationDataFromProps = () => {
		if (CoreHelper.isNullOrEmpty(animation)) {
			return loaderAnim;
		} else {
			return animation;
		}
	};

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationDataFromProps(),
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	return (
		<div>
			{loading && (
				<Dimmer inverted page={page} active style={{ backgroundColor: backgroundColor }}>
					<Lottie width={size} height={size} options={defaultOptions} isClickToPauseDisabled />
				</Dimmer>
			)}
		</div>
	);
};

LoaderComponent.defaultProps = {
	loading: false,
	page: false,
	size: 100,
};

export const Loader = LoaderComponent;
